import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Frame, FullScreenFrame } from './components/frames';
import { AdminHeader, CenteredHeader, CompanyManagerHeader, DemoHeader } from './components/headers';
import Tracks from './pages/admin/tracks/Tracks';
import Questionnaires from './pages/admin/questioneers/Questionnaires';
import Companies from './pages/admin/companies/Companies';
import CreateCompany from './pages/admin/companies/CreateCompany';
import ViewComapny from './pages/admin/companies/ViewCompany';
import CreateTrack from './pages/admin/tracks/create/CreateTrack';
import BuildTrack from './pages/admin/tracks/build/BuildTrack';
import CreateSpark from './pages/admin/materials/sparks/CreateSpark';
import CreateResource from './pages/admin/materials/resources/CreateResource';
import Materials from './pages/admin/materials/Materials';
import Programs from './pages/manager/Programs';
import Program from './pages/manager/Program';
import AuthFrame from './pages/auth/AuthFrame';
import Auth from './pages/auth/Auth';
import SignUp from './pages/auth/SignUp';
import ParticipantInvites from './pages/participant/ParticipantInvites';
import Dashboard from './pages/dashboard/Dashboard';
import TakeQuestionnaire from './pages/participant/enrollment/TakeQuestionnaire';
import ExploreSpark from './pages/ExplorSpark';
import Matching from './pages/participant/enrollment/Matching';
import ExplorTrack from './pages/ExplorTrack';
import Account from './pages/Account';
import ErrorToasts from './utils/errors/errorToast';
import Questionnaire from './pages/admin/questioneers/Questionnaire';
import Verify from './pages/auth/Verify';
import { ResetPassword } from './pages/auth/ResetPassword';
import ExploreResource from './pages/admin/ExploreResource';
import CreateQuestionnaire from './pages/admin/questioneers/create/CreateQuestionnaire';
import FailedLogins from './pages/admin/logins/FailedLogins';
import MatchingOverride from './pages/manager/MatchingOverride';
import ProgramStatistics from './pages/manager/stats/ProgramStatistics';
import ManageCompanyTracks from './pages/admin/companies/access/ManageCompanyTracks';
import ManageCompanyQuestionnaires from './pages/admin/companies/access/ManageCompanyQuestionnaires';
import ManageCompanySparks from './pages/admin/companies/access/ManageCompanySparks';
import ManagerSparks from './pages/manager/Sparks';
import ActivityTemplates from './pages/admin/activities/ActivityTemplates';
import CreateActivityTemplate from './pages/admin/activities/CreateActivityTemplate';

export default function App() {
    return (
        <Router>
            <ErrorToasts/>
            <Routes>

                <Route path='/' element={<AuthFrame />}>
                    <Route path='' element={<Auth />} />
                    <Route path='signup' element={<SignUp />} />               
                    <Route path='signup/:code' element={<SignUp />} />           
                    <Route path='verify-account' element={<Verify />} />
                    <Route path='reset-password' element={<ResetPassword/> } />
                </Route>

                <Route path='/admin' element={<Frame Header={AdminHeader} />}>
                    <Route path='account' element={<Account />} />
                    <Route path='companies'>
                        <Route path='' element={<Companies/>} />
                        <Route path='create' element={<CreateCompany/>} />
                        <Route path=':id'>
                            <Route path='' element={<ViewComapny/>} />
                            {exploreTrackRoutes()}
                            <Route path='questionnaire/:id' element={<Questionnaire/> } />
                            <Route path='manage-tracks' element={<ManageCompanyTracks/>} />
                            <Route path='manage-questionnaires' element={<ManageCompanyQuestionnaires/>} />
                            <Route path='manage-sparks' element={<ManageCompanySparks/>} />
                            <Route path='programs/:id'>
                                <Route path='' element={<Program/> } />
                                <Route path=':tab' element={<Program/> } />
                                {exploreTrackRoutes()}
                                <Route path='override' element={<MatchingOverride/> } />
                                <Route path='questionnaire/:id' element={<Questionnaire/> } />
                                <Route path='stats' element={<ProgramStatistics/> } />
                            </Route>
                        </Route>
                    </Route>
                    <Route path='tracks'>
                        <Route path='' element={<Tracks/>} />
                        <Route path='build' element={<BuildTrack/>} />
                        <Route path='build/:trackId' element={<BuildTrack/>} />
                        <Route path='create' element={<CreateTrack/>} />
                        <Route path=':id' element={<CreateTrack/>} />
                        <Route path=':id/preview'>
                            <Route path='' element={<ExplorTrack/>} />
                            <Route path='spark/:id' element={<ExploreSpark/>} />
                        </Route>
                    </Route>
                    <Route path='materials'>
                        <Route path='' element={<Materials/>} />

                        <Route path='sparks'>
                            <Route path='create' element={<CreateSpark/>} />
                            <Route path=':id' element={<CreateSpark/>} />
                        </Route>
                        
                        <Route path='resources'>
                            <Route path='create' element={<CreateResource/>} />
                            <Route path=':id' element={<ExploreResource/> } />
                        </Route>
                    </Route>
                    <Route path='questionnaires'>
                        <Route path='' element={<Questionnaires/>} />
                        <Route path='create' element={<CreateQuestionnaire/>} />
                        <Route path='create/:id' element={<CreateQuestionnaire/>} />
                        <Route path='duplicate/:id' element={<CreateQuestionnaire isDuplicate/>} />
                        <Route path=':id' element={<Questionnaire/> } />
                    </Route>
                    <Route path='activities'>
                        <Route path='' element={<ActivityTemplates/>}/>
                        <Route path='create' element={<CreateActivityTemplate/>}/>
                        <Route path=':id' element={<CreateActivityTemplate/>}/>
                    </Route>
                    <Route path='failed-logins' element={<FailedLogins/>} />
                </Route>

                <Route path='manager' element={<Frame Header={CompanyManagerHeader} />}>
                    <Route path='account' element={<Account />} />
                    <Route path='programs'>
                        <Route path='' element={<Programs/>} />
                        {exploreTrackRoutes()}
                        <Route path='questionnaire/:id' element={<Questionnaire/> } />
                        <Route path=':id'>
                            <Route path='' element={<Program/>}/>
                            <Route path=':tab' element={<Program/>}/>
                            {exploreTrackRoutes()}
                            <Route path='questionnaire/:id' element={<Questionnaire/> } />
                            <Route path='override' element={<MatchingOverride/> } />
                            <Route path='stats' element={<ProgramStatistics/> } />
                        </Route>
                    </Route>
                    <Route path='tracks'>
                        <Route path='' element={<Tracks/>}/>
                        <Route path='build' element={<BuildTrack/>}/>
                        <Route path='build/:trackId' element={<BuildTrack/>}/>
                        <Route path='create' element={<CreateTrack/>}/>
                        <Route path='edit/:id' element={<CreateTrack/>}/>
                        <Route path=':id'>
                            <Route path='' element={<ExplorTrack/>}/>
                            <Route path='spark/:id' element={<ExploreSpark/>}/>
                        </Route>
                    </Route>
                    <Route path='questionnaires'>
                        <Route path='' element={<Questionnaires/>}/>
                        <Route path='create' element={<CreateQuestionnaire/>}/>
                        <Route path='create/:id' element={<CreateQuestionnaire/>}/>
                        <Route path='duplicate/:id' element={<CreateQuestionnaire isDuplicate/>}/>
                        <Route path=':id' element={<Questionnaire/>}/>
                    </Route>
                    <Route path='sparks' element={<ManagerSparks/>}/>
                </Route>

                <Route path='participant/enrollment/:id/dashboard' element={<Dashboard/> } />
                <Route path='participant' element={<FullScreenFrame Header={CenteredHeader}/>}>
                    <Route path='account' element={<Account />} />
                    <Route path='invites' element={<ParticipantInvites/> } />
                    <Route path='invites/:invitationCode' element={<ParticipantInvites/> } />
                    <Route path='enrollment/:id'>
                        <Route path='questionnaire'>
                            <Route path='' element={<TakeQuestionnaire /> } />
                            {exploreTrackRoutes()}
                        </Route>
                        <Route path='matching' element={<Matching /> } />
                        <Route path='dashboard'>
                            <Route path='spark/:id' element={<ExploreSpark/> } />
                        </Route>
                    </Route>
                </Route>
            </Routes>
        </Router>
    )
}

const exploreTrackRoutes = () => (
    <Route path='track/:id'>
        <Route path='' element={<ExplorTrack/>} />
        <Route path='spark/:id' element={<ExploreSpark/> } />
    </Route>
)